import { render } from "./MbStoreDisplayPriceDisp.vue?vue&type=template&id=fcb4aa5c"
import script from "./MbStoreDisplayPriceDisp.vue?vue&type=script&lang=js"
export * from "./MbStoreDisplayPriceDisp.vue?vue&type=script&lang=js"

import "./MbStoreDisplayPriceDisp.vue?vue&type=style&index=0&id=fcb4aa5c&lang=scss"
script.render = render

export default script